import { CraAttributeName, Score, TreatmentType } from "@keita/lanepatrol-sdk";

export enum CraColoringType {
  Score = "Score",
  Treatment = "Treatment",
  Attribute = "Attribute",
}

export interface CraColoringScore {
  type: CraColoringType.Score;
  scoreKey: keyof Score;
}

export interface CraColoringTreatment {
  type: CraColoringType.Treatment;
  treatmentType: TreatmentType;
}

export interface CraColoringAttribute {
  type: CraColoringType.Attribute;
  attributeName: CraAttributeName;
}

export type CraColoring = CraColoringScore | CraColoringTreatment | CraColoringAttribute;
